export  const  city = [
    {"name": "Dubai", "population": 3137000, "country": "UAE"},
    {"name": "Abu Dhabi", "population": 2150000, "country": "UAE"},
    {"name": "Sharjah", "population": 1294000, "country": "UAE"},
    {"name": "Al Ain", "population": 766936, "country": "UAE"},
    {"name": "Ajman", "population": 490035, "country": "UAE"},
    {"name": "Ras Al Khaimah", "population": 345019, "country": "UAE"},
    {"name": "Fujairah", "population": 225360, "country": "UAE"},
    {"name": "Umm Al Quwain", "population": 72000, "country": "UAE"},
    {"name": "Khor Fakkan", "population": 33658, "country": "UAE"},
    {"name": "Dibba Al-Fujairah", "population": 30000, "country": "UAE"},
    {"name": "Dibba Al-Hisn", "population": 26393, "country": "UAE"},
    {"name": "Al Hamriyah", "population": 20000, "country": "UAE"},
    {"name": "Al Dhaid", "population": 15859, "country": "UAE"},
    {"name": "Ar-Rams", "population": 15738, "country": "UAE"},
    {"name": "Madinat Zayed", "population": 15320, "country": "UAE"},
    {"name": "Liwa Oasis", "population": 2000, "country": "UAE"},
    {"name": "Al Khis", "population": 2011, "country": "UAE"},
    {"name": "Masafi", "population": 10200, "country": "UAE"},
    {"name": "Meyzad", "population": 1040, "country": "UAE"}
  ];


  export  const  status = [
    {
      label:"Ordered",
      "id": "1"
    },
    {
      label:"Processing",
      "id": "2"
    },
    {
      label:"Packed",
      "id": "3"
    },
    {
      label:"Shiped",
      "id": "4"
    },
    {
      label:"Deliver",
      "id": "5"
    },
  ]


  export  const AllTarget = [
    {
        label: "Target",
        value: "target",
    },
    {
        label: "Revenue",
        value: "revenue",
    },
    {
        label: "Today",
        value: "today",
    },
];